module.exports = __webpack_public_path__ + "img/bdh-syt.238c2cbb.jpg";